import React from "react";

const Error = () => {
  return (
    <div className="w-[100vw] h-[100vh] bg-richblack-800 flex flex-col justify-center items-center gap-3">
      <p className="text-richblue-5 font-semibold text-4xl">Error - 404</p>
      <p className="text-richblue-5 font-semibold text-4xl">Page Not Found</p>
    </div>
  );
};

export default Error;
